import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../../../App/Components/PageContainer/PageContainer";
import { Button, Box, Paper } from "@mui/material";
import useAdminUserManagementState from "./State/AdminUsersState";
import SortableTable from "../../../App/Components/Table/SortableTable";
import AdminUserTableCell from "./Components/AdminUserTableCell";
import Modal from "../../../App/Components/Modals/Modal";
import { useModalHooks } from "../../../App/State/Hooks/useModalHooks";
import ModalForm from "../../../App/Components/Modals/Components/ModalForm";
import CreateUserForm from "../../ABAC/UsersPage/Components/CreateUserForm";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "../../../App/Typings/FeatureFlags";
export default function AdminUsersPage() {
  const { modalStatus, openModal } = useModalHooks();

  const {
    getters: { users, columns, usersLoading, createUserModalTitle, formik },
    handlers: { handleCreateModalClose },
  } = useAdminUserManagementState();

  // Initialize EnableABACApplicationManagement LD flag
  // TODO: Remove with ABAC-32
  const { enableAbacApplicationManagement } = useFlags<FeatureFlags>();

  return (
    enableAbacApplicationManagement && (
      <>
        <PageContainer>
          <Breadcrumb pageTitle={"Cross Client Users"} customBreadcrumbs={[]} />
          <h1 className="admin-page-title">Cross Client User Management</h1>
          <Paper sx={{ mt: 4, p: { xs: 2, lg: 4 } }}>
            <Box>
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    position: "absolute",
                    right: "0px",
                    top: "0px",
                    left: { xs: "0px", sm: "unset" },
                  }}
                  onClick={() => openModal()}
                >
                  Create New User
                </Button>
              </Box>
            </Box>
            <Box
              sx={{
                pt: { xs: "3rem", sm: "unset" },
              }}
            >
              <SortableTable
                columns={columns}
                tableData={users}
                rowComponent={AdminUserTableCell}
                loading={usersLoading}
                hideSearch={false}
                defaultSortIndex={0}
                setTableData={undefined}
                reverse={false}
                customProps={undefined}
              />
            </Box>
          </Paper>

          <Modal
            fullWidth
            maxWidth="lg"
            open={modalStatus.open === true}
            title={createUserModalTitle}
            hasLoadingBar={true}
            hasCloseButton={false}
            isProcessing={false}
            handleClose={handleCreateModalClose}
          >
            <ModalForm formik={formik} isProcessing={false}>
              <CreateUserForm />
            </ModalForm>
          </Modal>
        </PageContainer>
      </>
    )
  );
}
